import PropTypes from 'prop-types';
import React from 'react';
import DateField from './index';

export default function renderDateField({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;
  return (
    <DateField
      handleChangeStart={input.onChange}
      startDateValue={input.value}
      validationMessage={validationMessage}
      isValid={isValid}
      id={id}
      {...args}
      {...input}
    />
  );
}

renderDateField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.elementType,
    warning: PropTypes.string,
  }),
};
